import {
  AffiliateHierarchy,
  AffiliateRelationshipType,
  AffiliateRetirementType,
  AffiliateType,
} from '@/interfaces/affiliates';
import { Destination } from '@/interfaces/destination';

import {
  getAffiliateHierarchies,
  getAffiliateRelationshipTypes,
  getAffiliateRetirementTypes,
  getAffiliateTypes,
} from '@/services/affiliates.service';
import { queryDestinations } from '@/services/destinations.service';
import { orderBy } from 'lodash';

import { Effect, Reducer } from '@umijs/max';

export interface ModelType {
  namespace: string;
  state: {
    destinations: Destination[];
    affiliateTypes: AffiliateType[];
    hierarchies: AffiliateHierarchy[];
    retirementsTypes: AffiliateRetirementType[];
    relationshipTypes: AffiliateRelationshipType[];
    affiliateRetirementTypes: AffiliateRetirementType[];
  };
  effects: {
    fetchAffiliateTypes: Effect;
  };
  reducers: {
    setAffiliateTypes: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'newAffiliate',

  state: {
    hierarchies: [],
    destinations: [],
    affiliateTypes: [],
    retirementsTypes: [],
    relationshipTypes: [],
    affiliateRetirementTypes: [],
  },

  effects: {
    *fetchAffiliateTypes({ payload }, { call, put, all }) {
      const [
        affiliateTypes,
        affiliateRetirementTypes,
        hierarchies,
        destinations,
        retirementsTypes,
        relationshipTypes,
      ] = yield all([
        call(getAffiliateTypes, true),
        call(getAffiliateRetirementTypes, payload),
        call(getAffiliateHierarchies, payload),
        call(queryDestinations, payload),
        call(getAffiliateRetirementTypes, payload),
        call(getAffiliateRelationshipTypes, payload),
      ]);

      yield put({
        type: 'setAffiliateTypes',
        payload: {
          hierarchies: orderBy(hierarchies.data, 'name'),
          destinations: orderBy(destinations.data, 'name'),
          affiliateTypes: orderBy(affiliateTypes, 'name'),
          retirementsTypes: orderBy(retirementsTypes.data, 'name'),
          relationshipTypes: orderBy(relationshipTypes.data, 'name'),
          affiliateRetirementTypes: orderBy(affiliateRetirementTypes.data, 'name'),
        },
      });
    },
  },

  reducers: {
    setAffiliateTypes(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
